import React, { useState, useEffect, /*useRef*/ } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { reqGET, reqPUT } from '../../Utils';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import "../../assets/dataTable.css";
import parse from 'html-react-parser';
import ReactHtmlParser/*, { processNodes, convertNodeToElement, htmlparser2 }*/ from 'react-html-parser';

import Swal from 'sweetalert2'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";

import { getTokenInfo } from '../../UseToken';

import Loader from '../Loader/Loader';

    // Gilberto added »
import {
	set_language,
	content_language, 

} from '../../Utils';

import { language } from '../WEBContent/Language';

    export default function View(props) {

        const [dados, set_dados] = useState(data_interface);

        const [dados2, set_dados_2] = useState('');

        const [course_registration, set_course_registration] = useState(false);

        //const [course_registration_state, set_course_registration_state] = useState('');
    
        const [isloading, setLoading] = useState(true);
        const [isRedirect, setRedirect] = useState(false);
    
        const [lang, set_lang] = useState('pt');
        const [, set_lang_id] = useState('1');

        //const [funded_course_validation, set_funded_course_validation] = useState('');
        //const [non_funded_course_validation, set_non_funded_course_validation] = useState('');

        

        function finishRegistration() {

            if(dados.content[0].financing === 'financing_financed') {

                if(dados2.info.funded_course_validation === true){
                    Swal.fire({
                        title: language[lang].formation_registration,
                        html: language[lang].formation_registration_finish_text + '<b>' + dados.content[0].title + '.</b></br>' + language[lang].formation_registration_confirm,
                        icon: 'success',
                        showCancelButton: true,
                        confirmButtonColor: '#0095e8',
                        cancelButtonColor: '#d9214e',
                        confirmButtonText: language[lang].edit_confirm,
                        cancelButtonText: language[lang].edit_cancel
                    })

                    //Swal.fire(language[lang].formation_registration, language[lang].formation_registration_success, 'success')
                    .then((result) => {
                        if (result.isConfirmed) {

                            let data = new Date();
                            //let aDate = [data];

                            if(dados.content[0]['candidates'] === undefined)
                                dados.content[0]['candidates'] = []
                        
                            dados.content[0].candidates.push(
                                { 
                                    trainee_id: dados2.id,
                                    trainee_name: dados2.info.name + ' ' + dados2.info.surname,
                                    trainee_email: dados2.info.email,
                                    trainee_notified: false,
                                    trainee_status: 'under_review',
                                    trainee_request_date: data,
                                    trainee_response_date: ''
                                    //last_modification_date: data
                                }
                            );

                            reqPUT(api_crud_route, dados)
                                .then(() => {


                                    if(dados2.info['courses'] === undefined)
                                        dados2.info['courses'] = []
                                    
                                    dados2.info.courses.push(
                                        { 
                                            course_id: dados.id,
                                            course_name: dados.content[0].title,
                                            course_financed: (dados.content[0].financing === 'financing_financed' ? true : false),
                                            request_status: 'under_review',
                                            request_date: data,
                                            request_response_date: ''
                                        }
                                    );

                                    reqPUT(api_crud_base + '/entities/', dados2)
                                        .then(() => {
                                            
                                            Swal.fire({
                                                title: language[lang].formation_registration,
                                                html: language[lang].formation_registration_success,
                                                icon: 'success'
                                            })
                                            props.history.push('/courses_list');
                    
                                        })
                                        .catch((error) => { 
                                            Swal.fire(language[lang].formation_registration_finish_error, '', 'info')
                                            console.log('ERROR UPDATING TRAINEE DATA: ', error)
                                        })

                                    //Swal.fire(language[lang].formation_registration, language[lang].formation_registration_success, 'success')
                                    //props.history.push('/courses_list');

                                })
                                .catch((error) => { 
                                    Swal.fire(language[lang].formation_registration_finish_error, '', 'info')
                                    console.log('ERROR UPDATING FORMATION DATA: ', error)
                                })
                        }
                    })
                } else {

                    Swal.fire({
                        title: language[lang].formation_registration,
                        text: language[lang].formation_registration_warning,
                        icon: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#0095e8',
                        cancelButtonColor: '#d9214e',
                        confirmButtonText: language[lang].formation_registration_profile,
                        cancelButtonText: language[lang].cancel
                    })
                    .then((result) => {
                        if (result.isConfirmed) {

                            props.history.push({
                                pathname: '/trainee_regist',
                                state: {
                                    item: {id: getTokenInfo().id},
                                    operation: 'edit',
                                    secondary_operation: 'course_registration',
                                    course_id: dados.id,
                                    course_name: dados.content[0].title,
                                    course_financed: (dados.content[0].financing === 'financing_financed' ? true : false)
                                },
                            })
                            
                        }
                    }) 

                }

            }else{

                if(dados2.info.non_funded_course_validation === true){

                    Swal.fire({
                        title: language[lang].formation_registration,
                        html: language[lang].formation_registration_finish_text + '<b>' + dados.content[0].title + '.</b></br>' + language[lang].formation_registration_confirm,
                        icon: 'question',
                        showCancelButton: true,
                        confirmButtonColor: '#0095e8',
                        cancelButtonColor: '#d9214e',
                        confirmButtonText: language[lang].edit_confirm,
				        cancelButtonText: language[lang].edit_cancel
                    })

                    //Swal.fire(language[lang].regist, language[lang].regist_text, 'success')

                    .then((result) => {
                        if (result.isConfirmed) {

                            let data = new Date();
                            //let aDate = [data];

                            if(dados.content[0]['candidates'] === undefined)
                                dados.content[0]['candidates'] = []
                        
                            dados.content[0].candidates.push(
                                { 
                                    trainee_id: dados2.id,
                                    trainee_name: dados2.info.name + ' ' + dados2.info.surname,
                                    trainee_email: dados2.info.email,
                                    trainee_notified: false,
                                    trainee_status: 'under_review',
                                    trainee_request_date: data,
                                    trainee_response_date: ''
                                    //last_modification_date: data
                                }
                            );

                            reqPUT(api_crud_route, dados)
                                .then(() => {


                                    if(dados2.info['courses'] === undefined)
                                        dados2.info['courses'] = []
                                    
                                    dados2.info.courses.push(
                                        { 
                                            course_id: dados.id,
                                            course_name: dados.content[0].title,
                                            course_financed: (dados.content[0].financing === 'financing_financed' ? true : false),
                                            request_status: 'under_review',
                                            request_date: data,
                                            request_response_date: ''
                                        }
                                    );

                                    reqPUT(api_crud_base + '/entities/', dados2)
                                        .then(() => {
                                            
                                            Swal.fire({
                                                title: language[lang].formation_registration,
                                                html: language[lang].formation_registration_success,
                                                icon: 'success'
                                            })
                                            props.history.push('/courses_list');
                    
                                        })
                                        .catch((error) => { 
                                            Swal.fire(language[lang].formation_registration_finish_error, '', 'info')
                                            console.log('ERROR UPDATING TRAINEE DATA: ', error)
                                        })

                                    //Swal.fire(language[lang].formation_registration, language[lang].formation_registration_success, 'success')
                                    //props.history.push('/courses_list');

                                })
                                .catch((error) => { 
                                    Swal.fire(language[lang].formation_registration_finish_error, '', 'info')
                                    console.log('ERROR UPDATING FORMATION DATA: ', error)
                                })
                        }
                    })

                } else {

                    Swal.fire({
                        title: language[lang].formation_registration,
                        text: language[lang].formation_registration_warning,
                        icon: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#0095e8',
                        cancelButtonColor: '#d9214e',
                        confirmButtonText: language[lang].formation_registration_profile,
                        cancelButtonText: language[lang].cancel
                    })
                    .then((result) => {
                        if (result.isConfirmed) {

                            props.history.push({
                                pathname: '/trainee_regist',
                                state: {
                                    item: {id: getTokenInfo().id},
                                    operation: 'edit',
                                    secondary_operation: 'course_registration',
                                    course_id: dados.id,
                                    course_name: dados.content[0].title,
                                    course_financed: (dados.content[0].financing === 'financing_financed' ? true : false)
                                },
                            })
                            
                        }
                    }) 


                }

            }
        };
    
    
         // Para Instanciar todo o Objecto 
        const fetchInfo = async (id) => {
            await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
                .then(res => set_dados(res.data[0]))
                .catch(() => 404
                    //  TODO: ENVIAR PÃGINA 404
                    //  alert(error)); 
                );
        }
    
        useEffect(() => {

            const get_data_trainees = async () => {
    
                await reqGET(`${api_crud_base}/entities/${getTokenInfo().companycode}/${getTokenInfo().id}`)
                    .then(res => {
    
                        set_dados_2(res.data[0]);
    
                        //console.log(res.data[0])
                        //console.log(res.data[0].info.courses.length)
    
                        if(res.data[0].info.courses !== undefined && res.data[0].info.courses.length > 0) {
    
                            res.data[0].info.courses.forEach(v => {
    
                                if(v.course_id === props.location.state.item['id']) {
                                    set_course_registration(true)

                                    //set_course_registration_state(v.request_status)

                                }
                                //console.log('Array formandos:', v)
                                //set_funded_course_validation(v.info.funded_course_validation)
                                //set_non_funded_course_validation(v.info.non_funded_course_validation)
                            });
                        }
    
                    })
                    .catch( erro => { console.log( erro ) ; /*alert( 'Erro' );*/ } )
            }

            get_data_trainees();
    
            if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
                set_lang('pt')
                set_language('pt')
                set_lang_id('1')

            }
            else {
                set_lang(localStorage.getItem('lang'))
                content_language.forEach(el => {
                    if(el.code === localStorage.getItem('lang')) {
                        set_lang_id(el.id)
                    }
                })
            }
    
    
            if (props.location.state !== undefined) {
    
                fetchInfo(props.location.state.item['id']).then(() => {
                setLoading(false)

                })
            }
            else {
                setLoading(false);
                setRedirect(true);
            }
    
        }, [props]); 
    
    
        return isRedirect ?
            <Redirect to={endpoints.list} replace />
            :
            isloading ?
                
                <Loader />
            
                :
                
                <div id="kt_content" className="content d-flex flex-column flex-column-fluid">
                    <main>
                        <div className={`dash-cards-2 header`}>
                            {console.log('DADOS DA FORMAÇÃO---------->', dados)}
                            {console.log('DADOS 2 DO FORMANDO LOGGADO ---------->', dados2)}
                            {/*console.log('Campos validados para curso financiado: ', dados2.info.funded_course_validation)*/}
                            {/*console.log('Campos validados para curso não financiado: ', dados2.info.non_funded_course_validation)*/}
                            <h2 className="dash-title">{language[lang].courses_detail}</h2>
                            <span>
                                <Link to={{ pathname: endpoints.list }}  >
                                    {language[lang].courses_available}
                                </Link>
                                &nbsp;&#47;&nbsp;
                                {language[lang].courses_detail}</span>
                        </div>
    
                        <div className={`dash-cards-2 body col-10`}>
                            <div className="d-flex align-items-center mb-3">
                                <span className="title-red">{dados.content[0].title}</span>
                                {
                                    
                                    dados.content[0].candidates !== undefined && dados.content[0].candidates.length > 0 ? (
                                        dados.content[0].candidates.map((v2, index2) => {

                                            //verifica o estado da inscrição no array dos candidatos da formação

                                            if(v2.trainee_id === getTokenInfo().id) {

                                                let courseRegistered = false

                                                let courseRegisteredRejected = false

                                                let courseRegisteredWaiting = false

                                                if(v2.trainee_status === 'accepted'){
                                                    courseRegistered = true
                                                }

                                                if(v2.trainee_status === 'rejected'){
                                                    courseRegisteredRejected = true
                                                }

                                                if(v2.trainee_status === 'under_review'){
                                                    courseRegisteredWaiting = true
                                                }

                                                return (

                                                    <div key={index2}>
                                                        {
    
                                                            courseRegistered ? 
                                                                <span className="badge bg-success rounded-pill ms-3 py-2">{language[lang].formation_registered}</span>
                                                            : 
                                                            courseRegisteredRejected ? 
                                                                <span className="badge bg-danger rounded-pill ms-3 py-2">{language[lang].formation_registration_rejected}</span>
                                                            : 
                                                            courseRegisteredWaiting ?
                                                                <span className="badge bg-warning rounded-pill ms-3 py-2">{language[lang].formation_registration_waiting}</span>
                                                            : null
    
                                                        }
                                                    </div>
    
                                                )
                                            } else return null

                                            

                                        })
                                    ) : null  
                                }

                                {
                                    /*course_registration ? (

                                        //verifica o estado da inscrição no array de cursos no perfil do formando
                                        
                                        course_registration_state === 'accepted' ? 
                                            <span className="badge bg-success rounded-pill ms-3 py-2">{language[lang].formation_registered}</span>
                                        : 
                                        course_registration_state === 'rejected' ? 
                                            <span className="badge bg-danger rounded-pill ms-3 py-2">{language[lang].formation_registration_rejected}</span>
                                        : 
                                            <span className="badge bg-warning rounded-pill ms-3 py-2">{language[lang].formation_registration_waiting}</span>

                                    ) : null  */
                                        
                                }
                            </div>

                            {
                                dados.info.tags !== undefined && dados.info.tags.length > 0 ?
                                    <div className='tag fw-bold mb-3'>
                                        {dados.info.tags.map((v, k) => {  
                                            
                                            let aux_tag = v.text

                                            if(k > 0) {
                                                aux_tag = '; ' + v.text
                                            }
                                            return(
                                                <span key={k}>{aux_tag}</span>
                                            )
                                        })}
                                    </div>
                                : null
                            }
                            
                            {parse(dados.content[0].text)}

                            {
                                dados.content[0].abstract !== '' ?

                                    <div className={"mt-3"}>
                                        <span className="col-form-label fw-bold fs-6">{language[lang].objectives}</span>
                                        {parse(dados.content[0].abstract)}
                                    </div>
                                : null
                            }

                            {
                                dados.content[0].target !== '' ?
                                    <div className="mt-3">
                                        <span className="col-form-label fw-bold fs-6">{language[lang].target_audience}</span>
                                        {parse(dados.content[0].target)}
                                    </div>

                                : null
                            }

                            <div className={"mt-3"}>
                                <div className="row">
                                    {
                                        dados.info.date.begin !== '' ?
                                            <div className="col-4 mb-4">
                                                <span className="col-form-label fw-bold fs-6">{language[lang].start_date}</span>
                                                <p>{dados.info.date.begin.split('T')[0]}</p>
                                            </div>
                                        : null
                                    }
                                    {
                                        dados.info.date.registration_deadline !== '' ?
                                            <div className="col-4 mb-4">
                                                <span className="col-form-label fw-bold fs-6">{language[lang].date_registration_deadline}</span>
                                                <p>{dados.info.date.registration_deadline.split('T')[0]}</p>
                                            </div>
                                        : null
                                    }
                                    <div className="col-4 mb-4">
                                        <span className="col-form-label fw-bold fs-6">{language[lang].formation_language}</span>
                                        <p>{dados.content[0].formation_lang === 'formation_language_pt' ? language[lang].formation_language_pt : dados.content[0].formation_lang === 'formation_language_en' ? language[lang].formation_language_en : language[lang].formation_language_es}</p>
                                    </div>
                                    <div className="col-4 mb-4">
                                        <span className="col-form-label fw-bold fs-6">{language[lang].formation_modality}</span>
                                        <p>{dados.content[0].modality === 'formation_modality_classroom' ? language[lang].formation_modality_classroom : dados.content[0].modality === 'formation_modality_online' ? language[lang].formation_modality_online : language[lang].formation_modality_mixed}</p>
                                    </div>
                                    <div className="col-4 mb-4">
                                        <span className="col-form-label fw-bold fs-6">{language[lang].duration}</span>
                                        <p>{dados.content[0].duration}</p>
                                    </div>
                                    <div className="col-4 mb-4 d-none">
                                        <span className="col-form-label fw-bold fs-6">{language[lang].sessions_number}</span>
                                        <p>{dados.content[0].sessions}</p>
                                    </div>
                                    <div className="col-4 mb-4">
                                        <span className="col-form-label fw-bold fs-6">{language[lang].formation_schedule}</span>
                                        <p>{dados.content[0].schedule === 'formation_schedule_working_hours' ? language[lang].formation_schedule_working_hours : dados.content[0].schedule === 'formation_schedule_post_work' ? language[lang].formation_schedule_post_work : language[lang].formation_schedule_flexible}</p>
                                    </div>
                                    <div className="col-4 mb-4">
                                        <span className="col-form-label fw-bold fs-6">{language[lang].available_vacancies}</span>
                                        <p>{dados.content[0].vacancies}</p>
                                    </div>                                    
                                    <div className="col-4 mb-4">
                                        <span className="col-form-label fw-bold fs-6">{language[lang].financing}</span>
                                        <p>{dados.content[0].financing === 'financing_financed' ? language[lang].financing_financed : dados.content[0].financing === 'financing_free' ? language[lang].financing_free : language[lang].financing_paid}</p>
                                    </div>
                                    {
                                        dados.content[0].financing === 'financing_paid' ?
                                            <div className="col-4 mb-4">
                                                <span className="col-form-label fw-bold fs-6">{language[lang].formation_price}</span>
                                                <p>{dados.content[0].price}&euro;</p>
                                            </div>
                                        : null
                                    }
                                
                                    {
                                        dados.content[0].media.doc !== undefined && dados.content[0].media.doc.length > 0 ? (

                                            <div className='col-12 mb-4'>
                                                <label className='col-form-label fw-bold'>{language[lang].files}</label>
                                                {
                                                    dados.content[0].media.doc.map( ( v , index2 ) => {
                                                        
                                                        if(v.link === '')
                                                            return ''
                                                        else
                                                            return(
                                                                <div  key = { `${index2}` } className="mb-2">
                                                                    <i className="bi bi-bookmark me-2"></i>
                                                                    <a href={v.link} alt={language[lang].file_view} title={language[lang].file_view} target='_blank' rel="noreferrer">
                                                                        {v.name}
                                                                    </a>
                                                                </div>

                                                            )
                                                    })
                                                }
                                            </div>
                                        ) : null
                                    }
                                </div>
                            </div>

                            <div className="accordion mb-5" id="accordionCourse">
                                <span className="titulo-secundario">{language[lang].programme}</span>     
                            
                                {dados.content[0].modules.map((v, k) => {        
                                        
                                    return (
                                        <div key={k}>
                                            
                                            <div className="accordion-item mt-3">
                                                <div className="accordion-header" id={"heading-" + k}>
                                                    <button className={"accordion-button" + (k === 0 ? "" : " collapsed") } type="button" data-bs-toggle="collapse" data-bs-target={"#collapse-" + k} aria-expanded="true" aria-controls={"collapse-" + k}>
                                                        <span className="titulo-secundario">{language[lang].module}&nbsp;{k + 1} - {v.name}</span>
                                                    </button>
                                                </div>
                                              
                                                <div id={"collapse-" + k} className={"accordion-collapse collapse" + (k === 0 ? " show" : "")} aria-labelledby={"heading-" + k} data-bs-parent="#accordionCourse">
                                                    <div className="accordion-body">
                                                        
                                                        <div className='mb-3'>
                                                            <b>{ReactHtmlParser(v.sessions_number)}&nbsp;{v.sessions_number === '1' ? language[lang].session: language[lang].sessions} | {ReactHtmlParser(v.evaluation)}</b>
                                                            <span className="ps-3">
                                                                <FontAwesomeIcon className="me-2" icon={faClock} />
                                                                {ReactHtmlParser(v.duration)}&nbsp;{language[lang].hours}
                                                            </span>
                                                        </div>

                                                        {
                                                            v.description !== '' ?
                                                                <div className="mb-3">
                                                                    <span className="col-form-label fw-bold fs-6">{language[lang].description}</span>
                                                                    {ReactHtmlParser(v.description)}
                                                                </div>
                                                            : null
                                                        }
                                                        
                                                        {
                                                            v.objectives !== '' ?
                                                                <div className="mb-3">
                                                                    <span className="col-form-label fw-bold fs-6">{language[lang].objectives}</span>
                                                                    {ReactHtmlParser(v.objectives)}
                                                                </div>
                                                            : null
                                                        }
                                                        
                                                    </div>
                                                </div>

                                            </div>
                                            
                                        </div>
                                    )

                                })}
                            </div>

                        </div>

                        <div className={'dash-cards-2 footer'}>
                            <nav className="navbar bottom-navbar navbar-light">
                                <div className="navbar-footer">

                                    <ul className="navbar-nav float-left"></ul>

                                    <ul className="navbar-nav float-right">
                                        <li className="nav-item">
                                            <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                                <img alt='' src={'./img/seta_2.svg'} />
                                                <span>{language[lang].back}</span>
                                            </Link>
                                        </li> 
                                        {
                                            !course_registration ? (
                                                <li className={"nav-item "}>
                                                    <button type="button" onClick={() => finishRegistration()} className={"nav-link"} >
                                                        {/*img alt='' src={'./img/eliminar_b.svg'} />*/}
                                                        <span>{/*course_registration ? language[lang].formation_registered :*/ language[lang].formation_registration}</span>
                                                    </button>
                                                </li>
                                            ) : null
                                        }
                                        {/*<li className={"nav-item "}>
                                            <button type="button" onClick={() => finishRegistration()} className={"nav-link" + (course_registration ? ' bg-success border-success' : '')} disabled={course_registration ? true : false}>
                                                <span>{course_registration ? language[lang].formation_registered : language[lang].formation_registration}</span>
                                            </button>
                                        </li>*/}
                                    </ul>

                                </div>
                            </nav>
                        </div>
                    </main>
                </div>
    }